import { CommonActions } from '@react-navigation/native'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@zet/common/components/toast'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { i18n } from '@zet/localization'
import { LoggedInNavigation } from '@zet/utils/interface'

import useStore from '../../store'
import useMyCustomersStore from '../../store/myCustomers'
import { verifyEmploymentDetails } from '../functions'

export default function useVerifyEmploymentDetails() {
  const toast = useToast()
  const { isBrandsFlow, partnerId } = useMyCustomersStore((state) => state)
  const { dispatch } = useNavigation<LoggedInNavigation>()
  const queryClient = useQueryClient()
  const selectedCustomer = useStore((state) => state.selectedCustomer)
  return useMutation(verifyEmploymentDetails, {
    onSuccess: (response, variables) => {
      if (response?.customerStatus === 7 || response?.customerStatus === 5) {
        queryClient.invalidateQueries({ queryKey: ['home-widgets'] })
        queryClient.invalidateQueries({ queryKey: ['userCustomerCount'] })
        queryClient.invalidateQueries({ queryKey: ['userSummary'] })
        if (isBrandsFlow) {
          dispatch(
            CommonActions.reset({
              index: 1,
              routes: [
                {
                  name: 'BrandDetails',
                  params: {
                    brandId: partnerId,
                    routeName: 'category',
                  },
                },
                {
                  name: 'BrandSpecificRecommendationLoader',
                  params: {
                    customerId: variables?.customerId || '',
                    customerName: selectedCustomer?.name || '',
                    customerPhoneNumber: selectedCustomer?.phoneNumber || '',
                    brandId: partnerId,
                  },
                },
              ],
            })
          )
          return true
        }
        dispatch(
          CommonActions.reset({
            index: 1,
            routes: [
              { name: 'HomeView' },
              {
                name: 'BrandPage',
                params: {
                  customerId: variables?.customerId || '',
                  customerName: selectedCustomer?.name || '',
                  customerPhoneNumber: selectedCustomer?.phoneNumber || '',
                  showScratchCard: true,
                  routeName: 'forCustomerFlow',
                },
              },
            ],
          })
        )
      } else {
        toast?.show({
          intent: 'error',
          heading: i18n.t('toastMessages.error'),
          description: i18n.t('toastMessages.somethingWentWrong'),
          hideAfter: 3000,
        })
      }
    },
    onError: (error: string) => {
      toast?.show({
        intent: 'error',
        heading: i18n.t('toastMessages.error'),
        description: error,
        hideAfter: 3000,
      })
    },
  })
}
